import React from 'react'
import {Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Typography} from '@material-ui/core'

interface MovieCardProps {
    title: string,
    description?: string,
    poster: string,
    id: string | number
}

export default function MovieCard({id, title, description, poster}: MovieCardProps) {
	return (
		<Card className={'movie-card'}>
			<CardActionArea>
				<CardMedia
					image={poster}
					title={title}
				/>
				<CardContent>
					<Typography variant="caption" component="h2" style={{fontSize: '0.9rem'}}>
						{title}
					</Typography>
					<Typography variant="body2" color="textSecondary" component="p">
						{description}
					</Typography>
				</CardContent>
			</CardActionArea>
		</Card>
	)
}